<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'start-page.title'"></app-header-bar>
  </div>
  <div class="d-flex flex-row flex-wrap page-wrapper">
    <div class="card-wrapper">
      <div class="card">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <h3 class="card-title">
              <span translate>start-page.download-software.title</span>
            </h3>
            <p translate>start-page.download-software.description</p>
          </div>
          <div><a [routerLink]="['/software']" class="btn btn-primary" translate>start-page.download-software.action</a></div>
        </div>
      </div>
    </div>
    <div class="card-wrapper">
      <div class="card">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <h3 class="card-title">
              <span translate>start-page.create-ticket.title</span>
            </h3>
            <p translate>start-page.create-ticket.description</p>
          </div>
          <div><a [href]="'https://nimmsta.atlassian.net/servicedesk/customer/portals'" target="_blank" class="btn btn-primary" translate>start-page.create-ticket.action</a></div>
        </div>
      </div>
    </div>
    <div class="card-wrapper">
      <div class="card">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <h3 class="card-title">
              <span translate>start-page.productivity-cloud.title</span>
            </h3>
            <p translate>start-page.productivity-cloud.description</p>
          </div>
          <div><a [routerLink]="['/dashboard']" class="btn btn-primary" translate>start-page.productivity-cloud.action</a></div>
        </div>
      </div>
    </div>
    <div class="card-wrapper">
      <div class="card">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <h3 class="card-title">
              <span translate>start-page.documentation.title</span>
            </h3>
            <p translate>start-page.documentation.description</p>
          </div>
          <div><a [href]="environment.documentation2Url" target="_blank" class="btn btn-primary" translate>start-page.documentation.action</a></div>
        </div>
      </div>
    </div>
  </div>
</div>
